const values = [
  { icon: 'ri-shield-check-line', title: 'Clean & Safe', desc: 'Every property is regularly maintained and professionally cleaned to the highest standards.' },
  { icon: 'ri-heart-line', title: 'Reliable', desc: 'Consistent, dependable service with responsive support when you need it most.' },
  { icon: 'ri-map-pin-line', title: 'Convenient Location', desc: 'All properties are strategically positioned near public transport, shops, and local amenities.' },
  { icon: 'ri-user-smile-line', title: 'Tenant-Focused', desc: 'We prioritise your comfort, convenience, and overall wellbeing throughout your tenancy.' },
];

export default function AboutMission() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-0.5 bg-gold-500" />
              <span className="text-gold-500 text-sm font-medium tracking-widest uppercase">Our Mission</span>
            </div>
            <h2 className="font-heading text-4xl lg:text-5xl font-bold text-navy-800 leading-tight mb-6">
              Affordable, Reliable Housing for Every Stage of Life
            </h2>
            <p className="text-navy-700/70 text-base leading-relaxed mb-5">
              Galaxy Housing was founded on a simple belief: everyone deserves a clean, safe, and comfortable place to call home — whether they're in a bustling metro city or a regional Australian town — without the financial stress of managing multiple bills, the logistical nightmare of furnishing a property, or the uncertainty of unreliable management.
            </p>
            <p className="text-navy-700/70 text-base leading-relaxed mb-5">
              We specialise in medium and long-term furnished accommodation for working professionals, students, and individuals seeking a reliable housing solution. Our properties are spread across large regional areas and towns, as well as metro cities including Sydney, Brisbane, and Melbourne. Our all-inclusive model means one simple weekly payment covers your rent, electricity, water, gas, and Wi-Fi.
            </p>
            <p className="text-navy-700/70 text-base leading-relaxed">
              With professional oversight and a responsive support team, we ensure every property — from a regional town to the heart of a major city — is maintained to the highest standard. When issues arise, we respond: not tomorrow, not next week, but promptly.
            </p>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="w-full h-[500px] rounded-lg overflow-hidden">
              <img
                src="https://static.readdy.ai/image/18ca25ea8a69d5eb1e849ccadbb7687f/d89c06ac5b76b64a2abf62094824f8ca.jpeg"
                alt="Comfortable furnished living space"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 -left-5 bg-gold-500 text-navy-900 p-5 rounded-lg">
              <p className="font-heading font-bold text-2xl">All-Inclusive</p>
              <p className="text-sm font-medium mt-0.5">One payment, zero stress</p>
            </div>
          </div>
        </div>

        {/* Values */}
        <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v) => (
            <div key={v.title} className="text-center p-8 bg-navy-50 rounded-lg border border-navy-100" style={{ background: 'rgb(246,248,252)' }}>
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-navy-800 text-gold-400 mx-auto mb-4">
                <i className={`${v.icon} text-xl`} />
              </div>
              <h3 className="font-semibold text-navy-800 text-base mb-2">{v.title}</h3>
              <p className="text-navy-700/60 text-sm leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
